// src/event/eventContext.js
import { createContext, useContext } from 'react';

export const EventContext = createContext(null);

export function useEvent() {
  const ctx = useContext(EventContext);
  if (!ctx) throw new Error('useEvent must be used inside <EventProvider>');
  return ctx;
}
